/**
 *  Override $t('...') to inject lokalise.co
 */

import MessageFormat from "./MessageFormat";

export default class LokaliseFormatter {
    /**
     *
     * @param options
     */
    constructor (options = {}) {
        this._formatter = new MessageFormat();
        this._caches = Object.create(null)
    }

    interpolate (message, values, key) {
        let tokens = this._caches[message];
        let lokaliseAccess = process.env.MIX_LOKALISE_ACCESS === 'true';

        if (!tokens) {
            tokens = this._formatter.parse(message);
            this._caches[message] = tokens;
        }

        if (values) {
            message = this._formatter.compile(tokens, values);
            message = message.join('');
        }

        let lokaliseKey = '';

        if (values && values.ref) {
            lokaliseKey = values.ref
        } else {
            let splitKey = key.split('.');

            for (let i=1; i < splitKey.length - 1; i+=1) {
                lokaliseKey += `${splitKey[i]}::`;
            }

            lokaliseKey += `${splitKey[splitKey.length-1]}`;
        }

        if (!lokaliseAccess || values && values.html === false) {
            return [message]
        }

        let html = `<span data-lokalise data-key="${lokaliseKey}">${message}</span>`;
        // return the interpolated array
        return [html]
    }
}

